export enum AvailabilityBadgeType {
	Upcoming = 'upcoming',
	Leaving = 'leaving',
}

export enum AvailabilityBadgeSize {
	Short = 'short',
	Long = 'long',
}
